export default class List<T> extends Array<T> {
    constructor() {
        super();
        Object.setPrototypeOf(this, List.prototype);
    }

    public get head() {
        return this[0];
    }

    public get tail() {
        return this[this.length - 1];
    }

    public get isEmpty() {
        return this.length === 0;
    }
}

